import { render, staticRenderFns } from "./sky-text.vue?vue&type=template&id=89e15f2c&scoped=true"
import script from "./sky-text.vue?vue&type=script&lang=js"
export * from "./sky-text.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89e15f2c",
  null
  
)

export default component.exports